import { render, staticRenderFns } from "./PageAll.vue?vue&type=template&id=0c4b761f&scoped=true&"
import script from "./PageAll.vue?vue&type=script&lang=js&"
export * from "./PageAll.vue?vue&type=script&lang=js&"
import style0 from "./PageAll.vue?vue&type=style&index=0&id=0c4b761f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4b761f",
  null
  
)

export default component.exports